 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		39: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		39: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~12586329","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~3c55e86d","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~495fa908","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~8187b84f","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"StoryTemplateChunkstory-templates-listicle-story","7":"StoryTemplateChunkstory-templates-live-blog","8":"StoryTemplateChunkstory-templates-photo-story","9":"StoryTemplateChunkstory-templates-snapshot","10":"StoryTemplateChunkstory-templates-text-story","11":"StoryTemplateChunkstory-templates-video-story","12":"StoryTemplateChunkstory-templates-video-story-new","13":"StoryTemplateChunkstory-templates-video-story-old","14":"StoryTemplateChunkstory-templates-visual-story","15":"vendors~StoryTemplateChunkstory-templates-visual-story","16":"vendors~glide~home~list","17":"StoryTemplateChunkstory-templates-other","18":"StoryTemplateChunkstory-templates-photo-story-story-selectors","19":"StoryTemplateChunkstory-templates-story-selectors","20":"StoryTemplateChunkstory-templates-text-story-story-selectors","21":"StoryTemplateChunkstory-templates-video-story-new-paywall-video-story","22":"StoryTemplateChunkstory-templates-video-story-new-public-video-story","23":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","24":"vendors~StoryTemplateChunkstory-templates-video-story-new-public-video-story","25":"vendors~firebase-app~firebase-messaging","26":"vendors~home~list","28":"SSOWrapperBase","29":"SidebarTemplate","30":"StoryTemplateChunkstory-templates-blank-m-css","31":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","32":"StoryTemplateChunkstory-templates-live-blog-live-blog-module-css","33":"StoryTemplateChunkstory-templates-photo-story-photo-module-css","34":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","35":"StoryTemplateChunkstory-templates-text-story-text-story-m-css","36":"StoryTemplateChunkstory-templates-video-story-new-video-story-m-css","37":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","38":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","40":"firebase-app","42":"footer_1","43":"footer_2","44":"footer_3","45":"glide","46":"header_1","47":"header_2","48":"header_3","49":"header_4","50":"home","51":"list","52":"metypeFeedWidget","54":"qtc-parsecsv","55":"qtc-react-pdf","56":"secret-mode","58":"single-layer-header_1","59":"single-layer-header_2","60":"single-layer-header_3","61":"single-layer-header_4","62":"single-layer-header_5","63":"story","64":"subscription","65":"vendors~firebase-messaging","66":"vendors~pdfjsWorker","67":"vendors~qtc-react-pdf","68":"vendors~qtc-react-youtube","69":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + "5d6ae63d3342fb7b1dcf" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"17":1,"21":1,"22":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"56":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~12586329","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~3c55e86d","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~495fa908","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~8187b84f","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"StoryTemplateChunkstory-templates-listicle-story","7":"StoryTemplateChunkstory-templates-live-blog","8":"StoryTemplateChunkstory-templates-photo-story","9":"StoryTemplateChunkstory-templates-snapshot","10":"StoryTemplateChunkstory-templates-text-story","11":"StoryTemplateChunkstory-templates-video-story","12":"StoryTemplateChunkstory-templates-video-story-new","13":"StoryTemplateChunkstory-templates-video-story-old","14":"StoryTemplateChunkstory-templates-visual-story","15":"vendors~StoryTemplateChunkstory-templates-visual-story","16":"vendors~glide~home~list","17":"StoryTemplateChunkstory-templates-other","18":"StoryTemplateChunkstory-templates-photo-story-story-selectors","19":"StoryTemplateChunkstory-templates-story-selectors","20":"StoryTemplateChunkstory-templates-text-story-story-selectors","21":"StoryTemplateChunkstory-templates-video-story-new-paywall-video-story","22":"StoryTemplateChunkstory-templates-video-story-new-public-video-story","23":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","24":"vendors~StoryTemplateChunkstory-templates-video-story-new-public-video-story","25":"vendors~firebase-app~firebase-messaging","26":"vendors~home~list","28":"SSOWrapperBase","29":"SidebarTemplate","30":"StoryTemplateChunkstory-templates-blank-m-css","31":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","32":"StoryTemplateChunkstory-templates-live-blog-live-blog-module-css","33":"StoryTemplateChunkstory-templates-photo-story-photo-module-css","34":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","35":"StoryTemplateChunkstory-templates-text-story-text-story-m-css","36":"StoryTemplateChunkstory-templates-video-story-new-video-story-m-css","37":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","38":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","40":"firebase-app","42":"footer_1","43":"footer_2","44":"footer_3","45":"glide","46":"header_1","47":"header_2","48":"header_3","49":"header_4","50":"home","51":"list","52":"metypeFeedWidget","54":"qtc-parsecsv","55":"qtc-react-pdf","56":"secret-mode","58":"single-layer-header_1","59":"single-layer-header_2","60":"single-layer-header_3","61":"single-layer-header_4","62":"single-layer-header_5","63":"story","64":"subscription","65":"vendors~firebase-messaging","66":"vendors~pdfjsWorker","67":"vendors~qtc-react-pdf","68":"vendors~qtc-react-youtube","69":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"c3df0332bf9c534f4de5","4":"213da90d52914217d432","5":"31d6cfe0d16ae931b73c","6":"9c0349675cb1410f1482","7":"da975bc42efe4fbeed26","8":"39951cf43e5442013255","9":"9e1846d0107198eaa9c8","10":"b0c6ea6f24f126b291c4","11":"ae0ff27149fc7367281b","12":"fbfa11367964b29f52f1","13":"cbc4cd160c3c9b6e3317","14":"8fc1345e6a4c8676e91e","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"c39db7254a118235a88d","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"56524efc54fe4519e4ed","22":"e35de748bc5bb4e24905","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"acf8c787e76c83154ad1","27":"31d6cfe0d16ae931b73c","28":"a751517e4328b0ad33d7","29":"3a48db6f0391e03de3a4","30":"775be5d7b6c5f5605d5f","31":"53849cc3faa0f7c41546","32":"799e6d3e4540d43ce49b","33":"988b6694669bf0200dfe","34":"0c35b421194883ac71c1","35":"563ffc820c51303ce7d8","36":"8063b69d180099ca12fe","37":"9aa9bdde99cbef6edd54","38":"1a35dbe55fc5adce6eec","40":"31d6cfe0d16ae931b73c","42":"8e2ac9f97b5b41d27941","43":"beb7efde753797a08ff7","44":"7ca80661d31bb2a8c7c2","45":"5601a62b777eb193927d","46":"a897170a26822149d1d7","47":"cc3072fac782b4cb3708","48":"c3e35fc7b382b778af01","49":"96db8a04e80e62f2fdbd","50":"089e2df94c5dcef7b056","51":"5f54258cdf2f4b973923","52":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"499d1826a1fbbe7088dc","58":"56a301bef26be30b92d9","59":"22fd139b0e9b63aaee86","60":"00161dd24339d68dfcb9","61":"8ef33fbaeedf3956d6f5","62":"8ae35b8ade9ce5c59bd7","63":"8de13abcbd17ac45cb66","64":"067c573f0e295f52d8da","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"63": [
 				0,
 				1,
 				2,
 				3,
 				6,
 				7,
 				17,
 				8,
 				10,
 				11,
 				12,
 				21,
 				13,
 				24,
 				22,
 				15,
 				14,
 				30,
 				31,
 				32,
 				33,
 				18,
 				19,
 				20,
 				35,
 				36,
 				23,
 				37,
 				38
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 188);
